import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'Dashboard',
    icon: 'fas fa-chart-pie',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/dashboard/pedidos',
        title: 'Pedidos',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/dashboard/facturas',
        title: 'Facturación',
        icon: 'fas fa-chart-line',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/dashboard/historico',
        title: 'Histórico',
        icon: 'fas fa-chart-area',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Proceso',
    icon: 'fas fa-clipboard-list',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/proceso/ordenes-compra',
        title: 'Órdenes Compra',
        icon: 'fas fa-cart-plus',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/proceso/ordenes-plan',
        title: 'Órdenes Plan',
        icon: 'fas fa-hand-holding-usd',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/proceso/facturas',
        title: 'Facturas',
        icon: 'fas fa-dollar-sign',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Proceso THD',
    icon: 'fas fa-dolly',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/procesoTHD/asn',
        title: 'ASNs',
        icon: 'fas fa-dolly-flatbed',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/procesoTHD/consolidados',
        title: 'Consolidados',
        icon: 'fas fa-boxes',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Embarque',
    icon: 'fas fa-th',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/procesoTHD/embarques',
        title: 'Consolidados',
        icon: 'fas fa-boxes',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Catálogos',
    icon: ' fas fa-book',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/catalogos/articulos',
        title: 'Artículos',
        icon: 'fas fa-gamepad',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/catalogos/mdcs',
        title: 'MDCs',
        icon: 'fas fa-industry',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/catalogos/tiendas',
        title: 'Tiendas',
        icon: 'fas fa-shopping-cart',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/catalogos/tarimas',
        title: 'Tarimas',
        icon: 'fas fa-pallet',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/catalogos/transportista',
        title: 'Transportista',
        icon: 'fas fa-subway',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/catalogos/bitacora',
        title: 'Bitacora',
        icon: 'fas fa-clipboard-list',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Administración',
    icon: 'fas fa-address-book',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/clientes',
        title: 'Proveedores',
        icon: 'fas fa-people-carry',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/empresas',
        title: 'Empresas',
        icon: 'fas fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/canales',
        title: 'Canales',
        icon: 'fas fa-signal',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/roles',
        title: 'Roles',
        icon: 'fas fa-lock',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/usuarios',
        title: 'Usuarios',
        icon: 'fas fa-users',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Configuración',
    icon: 'fas fa-cogs',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/parametros',
        title: 'Parámetros',
        icon: 'fas fa-sliders-h',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/validaciones',
        title: 'Validaciones',
        icon: 'fas fa-clipboard-check',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  /*{
    path: '',
    title: 'Ayuda',
    icon: 'fas fa-info',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/parametros',
        title: 'Acerca De',
        icon: 'far fa-address-card',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  }*/
];
